import React from 'react';
import { Button } from '../..';
import styles from './styles';

type Props = {
  title: string;
  onClick: () => void;
};

const PreviewButton = ({ title, onClick }: Props) => {
  const classes = styles();

  return (
    <Button
      onClick={onClick}
      variant="text"
      color="default"
      className={classes.groupAction}
    >
      {title}
    </Button>
  );
};

export default PreviewButton;
